
export function Footer() {
    return (
        <footer>
            <span>© 2026 Arztpraxis Wagner für Allgemeinmedizin · Rüsselsheim</span>
        </footer>
    );
}
